<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPlay_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="m14.087 8.999-8.543 4.876a1.15 1.15 0 0 1-1.721-.999V3.124a1.15 1.15 0 0 1 1.72-.999l8.542 4.877a1.15 1.15 0 0 1 .002 1.997Z"
    />
</svg>
